//ADD_COMPANY
export const USER_ADD_COMPANY_REQUEST = "USER_ADD_COMPANY_REQUEST";
export const USER_ADD_COMPANY_SUCCESS = "USER_ADD_COMPANY_SUCCESS";
export const USER_ADD_COMPANY_FAIL = "USER_ADD_COMPANY_FAIL";
export const USER_ADD_COMPANY_RESET = "USER_ADD_COMPANY_RESET";

//USER_GET_MY_COMPANIES
export const USER_GET_MY_COMPANIES_REQUEST = "USER_GET_MY_COMPANIES_REQUEST";
export const USER_GET_MY_COMPANIES_SUCCESS = "USER_GET_MY_COMPANIES_SUCCESS";
export const USER_GET_MY_COMPANIES_FAIL = "USER_GET_MY_COMPANIES_FAIL";

//USER_GET_MY_DEPARTMENT
export const USER_GET_MY_DEPARTMENT_REQUEST = "USER_GET_MY_DEPARTMENT_REQUEST";
export const USER_GET_MY_DEPARTMENT_SUCCESS = "USER_GET_MY_DEPARTMENT_SUCCESS";
export const USER_GET_MY_DEPARTMENT_FAIL = "USER_GET_MY_DEPARTMENT_FAIL";

//ALL_USER_FROM_COMPANY_LIST
export const ALL_USER_FROM_COMPANY_LIST_REQUEST =
  "ALL_USER_FROM_COMPANY_LIST_REQUEST";
export const ALL_USER_FROM_COMPANY_LIST_SUCCESS =
  "ALL_USER_FROM_COMPANY_LIST_SUCCESS";
export const ALL_USER_FROM_COMPANY_LIST_FAIL =
  "ALL_USER_FROM_COMPANY_LIST_FAIL";

//GET_COMPANY_OWNER
export const GET_COMPANY_OWNER_REQUEST = "GET_COMPANY_OWNER_REQUEST";
export const GET_COMPANY_OWNER_SUCCESS = "GET_COMPANY_OWNER_SUCCESS";
export const GET_COMPANY_OWNER_FAIL = "GET_COMPANY_OWNER_FAIL";

//GET_USER_COMPANIES

export const GET_USER_COMPANIES_REQUEST = "GET_USER_COMPANIES_REQUEST";
export const GET_USER_COMPANIES_SUCCESS = "GET_USER_COMPANIES_SUCCESS";
export const GET_USER_COMPANIES_FAIL = "GET_USER_COMPANIES_FAIL";

//CHANGE_USER_COMPANY

export const CHANGE_USER_COMPANY_REQUEST = "CHANGE_USER_COMPANY_REQUEST";
export const CHANGE_USER_COMPANY_SUCCESS = "CHANGE_USER_COMPANY_SUCCESS";
export const CHANGE_USER_COMPANY_FAIL = "CHANGE_USER_COMPANY_FAIL";
